import type { GraphEdge, GraphNode } from './nodeDefs.js';

export type DataFieldType = 'bool' | 'number' | 'string' | 'vec2' | 'vec3' | 'vec4';

export interface DataFieldDef {
  /** Literal object-key segments relative to one record. */
  path: string[];
  type: DataFieldType;
}

export interface DataSourceDef {
  provider: string;
  resource: string;
  credential?: string;
  records: DataRecordsDef;
  keyType: 'bool' | 'number' | 'string';
  fields: Record<string, DataFieldDef>;
}

export interface DataRecordsDef {
  path: Array<string | number>;
  kind: 'array' | 'map';
}

export const ROOT_DATA_RECORDS: DataRecordsDef = { path: [], kind: 'map' };

export interface DataGraphDef {
  nodes: GraphNode[];
  edges: GraphEdge[];
}

export type QueryGraphDef = DataGraphDef;

export interface DataGraphInstance {
  use: string;
  bindings: Record<string, string>;
  /** Per-owner values consumed by typed Data `Input` nodes. */
  inputs?: Record<string, boolean | number | string | number[] | null>;
}

export interface SceneDataContext {
  source: string;
  key: boolean | number | string;
}

export function cloneDataGraph(graph: DataGraphDef): DataGraphDef {
  return {
    nodes: graph.nodes.map(node => ({ ...node, data: { ...node.data } })) as GraphNode[],
    edges: graph.edges.map(edge => ({ ...edge })),
  };
}

export function dataGraphOutputNodes(graph: DataGraphDef): GraphNode[] {
  return graph.nodes.filter(node => node.type === 'Output');
}

export function dataGraphOutputNames(graph: DataGraphDef): string[] {
  return dataGraphOutputNodes(graph).map(node => String(node.data.inputName || 'Output'));
}
